/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

import PortalVue from 'portal-vue';
Vue.use(PortalVue);

import route from 'ziggy-js';
import { Ziggy } from 'ziggy-js';

Vue.mixin({
    methods: {
        route: (name, params, absolute) => route(name, params, absolute, Ziggy),
    },
});

window.createToast = (heading, text='', success=true) => {
    bus.$emit('create-toast', { heading: heading, text: text, success: success });
};

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('add-to-basket-event', require('./components/basket/add/Event').default);
Vue.component('add-to-basket-product', require('./components/basket/add/Product').default);

Vue.component('basket-checkout', require('./components/basket/Checkout').default);
Vue.component('basket-menu', require('./components/basket/Menu').default);

Vue.component('event-calendar', require('./components/Calendar').default);

Vue.component('customer-menu', require('./components/customer/Menu').default);
Vue.component('customer-review-form', require('./components/forms/CustomerReviewForm').default);

Vue.component('enquiry-form', require('./components/forms/EnquiryForm').default);

Vue.component('event-reviews', require('./components/EventReviews').default);
Vue.component('event-waiting-list', require('./components/EventWaitingList').default);

Vue.component('image-rotator', require('./components/rotator/Rotator.vue').default);
Vue.component('image-rotator-image', require('./components/rotator/Image.vue').default);

Vue.component('lead-form', require('./components/forms/LeadForm').default);

Vue.component('membership-pricing', require('./components/membership/pricing/Container.vue').default);

Vue.component('notifications', require('./components/notifications/Container.vue').default);

Vue.component('mobile-menu', require('./components/MobileMenu.vue').default);

Vue.component('tab-container', require('./components/tabs/Container.vue').default);
Vue.component('tab-item', require('./components/tabs/Tab.vue').default);
Vue.component('tab-content', require('./components/tabs/Content.vue').default);

Vue.component('toasts-container', require('./components/toasts/Container.vue').default);

// Views
Vue.component('checkout-account', require('./views/checkout/Account.vue').default);
Vue.component('checkout-billing', require('./views/checkout/Billing.vue').default);
Vue.component('checkout-payment', require('./views/checkout/Payment.vue').default);

Vue.component('customer-booking-edit', require('./views/customer/bookings/Edit.vue').default);

Vue.component('customer-membership-billing', require('./views/customer/membership/Billing.vue').default);
Vue.component('customer-membership-contract', require('./views/customer/membership/Contract.vue').default);

Vue.component('customer-orders-index', require('./views/customer/orders/Index.vue').default);
Vue.component('customer-orders-show', require('./views/customer/orders/Show.vue').default);

Vue.component('customer-seat-invitation-edit', require('./views/customer/bookings/seats/invitations/Edit.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

window.bus = new Vue();

const app = new Vue({
    el: '#app',

    methods: {
        goToLocation(e) {
            window.location = e.target.value;
        }
    }
});
